import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { PercentPipe } from '@angular/common';
import { ActivityProgressData } from '../../models/report.model';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-activity-progress-report',
    templateUrl: './activity-progress-report.component.html',
    styleUrls: ['./activity-progress-report.component.scss'],
    standalone: false
})
export class ActivityProgressReportComponent implements OnInit {
    @Input() ActivityProgressData: ActivityProgressData;

    recommentedRateofWork: number;
    pipe: any = new PercentPipe('en-US');
    totalWorkpacks: any[];
    totalactivityPackTaggedItem: any[];
    activityPackCustomColors: any = [];
    activityPackTaggedItemCustomColors: any = [];
    activityPackTaggedItemActivity: any[];
    isWorkpacksTotal: boolean = false;
    isactivityPackTaggedItemTotal: boolean = false;
    title1: string = this.transLocoService.translate('IDMS.REPORTS.ACTIVITY_PACK_PROGRESS_TRACKER');
    title2: string = this.transLocoService.translate('IDMS.REPORTS.JOINT_PROGRESS_TRACKER');
    constructor(
        private cd: ChangeDetectorRef,
        private transLocoService: TranslocoService
    ) {}
    customizeTooltip = (arg: any) => {
        return {
            text: this.pipe.transform(arg.percent, '1.2-2'),
        };
    };

    ngOnInit(): void {
        this.getAndSetUpChart();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.getAndSetUpChart();
    }

    getAndSetUpChart() {
        //For Activity Pack
        let checkArray = this.ActivityProgressData?.activityPack.map((x) => x.key); //['Not Started', 'In Progress', 'Complete'];
        this.totalWorkpacks = this.ActivityProgressData.activityPack.filter((x) => checkArray.includes(x.key) && x.colour != undefined).sort();
        const totalItem = this.ActivityProgressData.activityPack.find((x) => x.key === 'Total');

        this.isWorkpacksTotal = totalItem?.value === 0;
        // let everyCheck = this.totalWorkpacks.every((x) => x.value == 0);
        // if (everyCheck) {
        //     this.totalWorkpacks.map((y) => {
        //         if (y.key == 'Not Started') {
        //             y.value = 100;
        //         }
        //     });
        // }
        this.activityPackCustomColors = this.totalWorkpacks.map((x) => x.colour);
        //For Activity Pack Taggeditem
        this.totalactivityPackTaggedItem = this.ActivityProgressData.activityPackTaggedItem
            .filter((x) => checkArray.includes(x.key) && x.colour != undefined)
            .sort();
        const activityPackTaggedItemTotal = this.ActivityProgressData.activityPackTaggedItem.find((x) => x.key === 'Total');

        this.isactivityPackTaggedItemTotal = activityPackTaggedItemTotal?.value === 0;
        if (this.ActivityProgressData?.activityPackTaggedItemActivity) {
            this.activityPackTaggedItemCustomColors = this.totalactivityPackTaggedItem.map((x) => x.colour);
            //For ActivityTaggedItemActivity
            // this.activityPackCustomColors = this.totalWorkpacks.map((x) => x.colour);
            this.activityPackTaggedItemActivity = this.groupBy(this.ActivityProgressData.activityPackTaggedItemActivity, 'group');
        } else {
            this.activityPackTaggedItemActivity = null;
        }
        this.cd.detectChanges();
    }

    groupBy(array: any[], key: string) {
        return array.reduce((result, currentValue) => {
            (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
            return result;
        }, {});
    }

    orderComparator(a: any, b: any): number {
        return a.value.order - b.value.order;
    }
}
